import createStyleSheet from 'src/utilities/createStyleSheet'

export const lprGridTableStyles = createStyleSheet({
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    minHeight: '72vh',
    '@media(max-width:1540px)': {
      minHeight: '70vh',
    },
  },
  noRegisters: {
    fontFamily: "'Inter', 'sans-serif'",
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 'auto',
    fontWeight: 450,
    '@media(max-width:1540px)': {
      fontSize: '0.95em',
    },
  },
})
